/**
 * @fileoverview Select the staff destination policy for client-portal notifications. The backend owns saved settings and eligible recipient identities; this editor owns the draft recipient choice and explicit save. `kc-internal-backend/services/portal_notifications.py` owns actual eligibility/delivery checks. Configuring a destination and acknowledging delivery are separate state.
 */

import React, { useEffect, useState } from 'react';
import api from '../../api';
import './PortalNotificationSettings.css';



export default function PortalNotificationSettings() {
  const [settings, setSettings] = useState(null);
  const [recipient, setRecipient] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    let active = true;
    api.get('/settings/portal-notifications').then(({ data }) => {
      if (active) { setSettings(data); setRecipient(data.recipient_mode === 'employee' ? String(data.recipient_employee_id || '') : 'attorneys'); }
    }).catch(() => { if (active) setError('Administrator access is required, or settings could not be loaded.'); });
    return () => { active = false; };
  }, []);
  

  async function save() {
    setSaving(true); setError(''); setMessage('');
    try {
      await api.put('/settings/portal-notifications', recipient === 'attorneys' ? { recipient_mode: 'attorneys', recipient_employee_id: null } : { recipient_mode: 'employee', recipient_employee_id: Number(recipient) });
      setMessage('Notification recipient saved. Applies to new submissions.');
    } catch (e) { setError(e.response?.data?.error || 'Could not save the recipient.'); }
    finally { setSaving(false); }
  }
  return <section className="settings-card portal-notification-settings" aria-labelledby="portal-notifications-heading">
    <h2 id="portal-notifications-heading">Client portal notifications</h2>
    <p>Case attorneys always receive verification and banking results. Choose an additional recipient if needed.</p>
    {error ? <p role="alert">{error}</p> : null}
    {!settings && !error ? <p role="status">Loading notification settings…</p> : null}
    {settings ? <>
      <div className="portal-notification-settings__field"><label htmlFor="portal-recipient">Additional Slack recipient</label>
      <select id="portal-recipient" className="task-inbox__assignment-select" value={recipient} onChange={(e) => { setRecipient(e.target.value); setMessage(''); }} disabled={saving}>
        <option value="attorneys">Case attorneys only (default)</option>
        {settings.recipients.map((person) => <option key={person.id} value={person.id}>{person.name} · {person.email}</option>)}
      </select></div>
      <div className="portal-notification-settings__actions">
      <button className="task-inbox__button" type="button" disabled={!recipient || saving} onClick={save}>{saving ? 'Saving…' : 'Save recipient'}</button>
      {!settings.delivery_enabled ? <span className="portal-notification-settings__preview">Preview mode · Slack delivery off</span> : null}
      </div>
    </> : null}
    {message ? <p role="status">{message}</p> : null}
  </section>;
}
